import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { decodeAiChatPayload } from 'webapp/utils/ai-chat-payload';

import type MobileGenieChatController from 'webapp/controllers/mobile/genie/chat';

export default class MobileGenieChatRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	override queryParams = {
		chat: { refreshModel: true },
	};

	override async beforeModel(): Promise<void> {
		await this.mmBoardsService.requestBoards();
	}

	override setupController(controller: MobileGenieChatController, model: unknown): void {
		super.setupController(controller, model);

		if (controller.chat) {
			const payload = decodeAiChatPayload(controller.chat);

			if (payload) {
				controller.setup(payload);
			} else {
				this.infolayerService.error('Invalid chat link. Starting a new conversation.');
			}

			controller.chat = null;
		}
	}

	override resetController(controller: MobileGenieChatController, isExiting: boolean): void {
		if (isExiting) {
			controller.reset();
		}
	}
}
